import type { $Fetch } from 'ofetch';
import type { ContratoGateway } from '@/application/port/out/ContratoGateway';
import type {
  GerarContratoCommand,
  RenderizarContratoCommand,
} from '@/application/port/in/dto/ContratoCommand';
import type { Contrato } from '@/domain/model/Contrato';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const PATH = '/api/v1/enrollment/contratos';

export class HttpContratoGateway implements ContratoGateway {
  constructor(private readonly client: $Fetch) {}

  async listByMatricula(matriculaId: string): Promise<Contrato[]> {
    const res = await this.client<ApiResponse<Contrato[]>>(
      `${PATH}/matricula/${encodeURIComponent(matriculaId)}`,
      { method: 'GET' },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async getById(id: string): Promise<Contrato> {
    const res = await this.client<ApiResponse<Contrato>>(
      `${PATH}/${encodeURIComponent(id)}`,
      { method: 'GET' },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async gerar(command: GerarContratoCommand): Promise<Contrato> {
    const res = await this.client<ApiResponse<Contrato>>(
      `${PATH}/matricula/${encodeURIComponent(command.matriculaId)}/gerar`,
      { method: 'POST' },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async renderizar(command: RenderizarContratoCommand): Promise<Contrato> {
    const res = await this.client<ApiResponse<Contrato>>(
      `${PATH}/${encodeURIComponent(command.contratoId)}/renderizar`,
      { method: 'POST' },
    );
    assertApiSuccess(res);
    return res.data;
  }

  async cancelar(id: string): Promise<void> {
    // Backend responde 204 No Content (sem envelope ApiResponse).
    await this.client<null>(`${PATH}/${encodeURIComponent(id)}`, {
      method: 'DELETE',
    });
  }

  async registrarAssinatura(id: string, clicksignKey: string): Promise<Contrato> {
    const res = await this.client<ApiResponse<Contrato>>(
      `${PATH}/${encodeURIComponent(id)}/assinar`, { method: 'PATCH', body: { clicksignKey } });
    assertApiSuccess(res);
    return res.data;
  }
}
